import { ForwardRefExoticComponent, ReactNode, RefAttributes } from 'react'

import { Asable } from '../../../types/asable'
import { LocaleIdentifier } from '../../../types/localeIdentifier'
import { DEFAULT_FORMATTER_LOCALE } from '../../constants/defaultFormatterLocale'
import { DateTimeFormat } from '../../utils/DateTimeFormat'
import { FormattedElement } from '../elements/FormattedElement'
import { FormattedDate } from './elements/FormattedDate'
import { FormattedTime } from './elements/FormattedTime'

export interface FormattedDateTimeProps extends Asable {
  asString?: boolean
  locale?: LocaleIdentifier
  options?: Intl.DateTimeFormatOptions
  value?: Date
}

type FormattedDateTimeType = ForwardRefExoticComponent<FormattedDateTimeProps & RefAttributes<HTMLDivElement>> & {
  Date: typeof FormattedDate
  Time: typeof FormattedTime
}

export const FormattedDateTime = (({
  as = 'span',
  asString = false,
  locale = DEFAULT_FORMATTER_LOCALE,
  options,
  value,
}: FormattedDateTimeProps): ReactNode => {
  return (
    <FormattedElement as={as} asString={asString}>
      {DateTimeFormat.getFormattedDateTime(value, locale, options)}
    </FormattedElement>
  )
}) as FormattedDateTimeType

FormattedDateTime.Date = FormattedDate
FormattedDateTime.Time = FormattedTime

// export corresponding prop types:
export type { FormattedDateProps } from './elements/FormattedDate'
export type { FormattedTimeProps } from './elements/FormattedTime'
